module.exports = __webpack_public_path__ + "img/videid.b8917979.jpg";